module.exports = __webpack_public_path__ + "static/media/align-center-justify.307b1058.svg";